// reducers/chat/chat.js

// --- ALL ---

export function chatHasErrored(state = false, action) {
  switch (action.type) {
    case 'CHAT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function chatIsLoading(state = false, action) {
  switch (action.type) {
    case 'CHAT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function chat(state = {}, action) {
  switch(action.type) {
    case 'CHAT_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}